// useResize.tsx
import * as React from "react";
const {
  useState,
  useEffect
} = React;

const useWindowDimensions = () => {
  const [x, setX] = useState(null);
  const [y, setY] = useState(null);
  useEffect(() => {
    window.addEventListener("resize", e => {
      setX(window.innerWidth);
      setY(window.innerHeight);
    });
    return window.removeEventListener("resize", () => {});
  }, []);
  return [x, y];
};

export default useWindowDimensions;